<section class="video-background-section">
    <div class="video-container">
      <video #backgroundVideo class="background-video" [poster]="posterImage" autoplay muted loop playsinline>
        <source [src]="videoUrl" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  
    <div class="content-container">
      <div class="text-box">
        <div class="text-content">
          <h2 class="heading">
            <span>Unlock Your Potential with our</span> 
            <span class="highlight">Affiliate Marketing Programme</span>
          </h2>
          <p class="description">
            Our affiliate program offers more than just commissions. Enjoy a host of benefits—from advanced marketing tools and real-time analytics to dedicated partner support—all designed to boost your revenue potential and empower your affiliate journey.
          </p>
        </div>
      </div>
  
      <div class="button-container">
        <button class="primary-button" (click)="joinUs()">
          <span>Join Us</span>
          <span class="button-icon">
            <svg viewBox="0 0 200 200" height="200" width="200" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 29.5c-38.874 0-70.5 31.626-70.5 70.5s31.626 70.5 70.5 70.5 70.5-31.626 70.5-70.5-31.626-70.5-70.5-70.5zm0 133c-34.463 0-62.5-28.037-62.5-62.5S65.537 37.5 100 37.5s62.5 28.037 62.5 62.5-28.037 62.5-62.5 62.5zm30.09-60.584c-.055.101-.099.205-.164.302a3.99 3.99 0 0 1-.501.613l-26.597 26.597c-.78.781-1.805 1.172-2.828 1.172s-2.048-.391-2.828-1.172a4 4 0 0 1 0-5.656L116.943 104H73.4a4 4 0 0 1 0-8h43.542l-19.77-19.771a4 4 0 1 1 5.656-5.656l26.597 26.597c.187.187.354.392.501.613.065.097.109.201.164.302.07.127.147.25.203.386.055.132.086.27.126.405.034.114.078.223.101.341.103.517.103 1.05 0 1.566-.023.118-.068.227-.101.341-.04.136-.071.273-.126.405-.055.136-.132.259-.203.387z"></path>
            </svg>
          </span>
        </button>
        <button class="secondary-button" (click)="learnMore()">
          <span>Learn More</span>
          <span class="button-icon">
            <svg viewBox="0 0 200 200" height="200" width="200" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 29.5c-38.874 0-70.5 31.626-70.5 70.5s31.626 70.5 70.5 70.5 70.5-31.626 70.5-70.5-31.626-70.5-70.5-70.5zm0 133c-34.463 0-62.5-28.037-62.5-62.5S65.537 37.5 100 37.5s62.5 28.037 62.5 62.5-28.037 62.5-62.5 62.5zm30.09-60.584c-.055.101-.099.205-.164.302a3.99 3.99 0 0 1-.501.613l-26.597 26.597c-.78.781-1.805 1.172-2.828 1.172s-2.048-.391-2.828-1.172a4 4 0 0 1 0-5.656L116.943 104H73.4a4 4 0 0 1 0-8h43.542l-19.77-19.771a4 4 0 1 1 5.656-5.656l26.597 26.597c.187.187.354.392.501.613.065.097.109.201.164.302.07.127.147.25.203.386.055.132.086.27.126.405.034.114.078.223.101.341.103.517.103 1.05 0 1.566-.023.118-.068.227-.101.341-.04.136-.071.273-.126.405-.055.136-.132.259-.203.387z"></path>
            </svg>
          </span>
        </button>
      </div>
    </div>
  </section>